import usePermissions from './usePermissions';

/**
 * Quién administra el widget web (listado, editor, límites): los administradores de la cuenta
 * siempre; el resto, solo con el permiso `social-media.widget`. La reportería tiene el suyo
 * (`useWidgetReportAccess`).
 */
const useWidgetAccess = () => {
  const { isAccountAdmin, can } = usePermissions();
  return { canManageWidgets: Boolean(isAccountAdmin) || can('social-media.widget') };
};

export default useWidgetAccess;
